export default [
  {
    path: '/apps/permissao/list',
    name: 'apps-permissao-list',
    component: () => import('@/views/sistema/permissoes/list/Index.vue'),
    meta: {
      pageTitle: 'Permissões',
      resource: 'AdminHanes',
    },
  },
];
